// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__Hr8gV","additionalInfo":"AgreementModal_additionalInfo__12T0G"};